import { createFileRoute } from '@tanstack/react-router';

import StoreRevisionsPage from '@/components/store/revisions/Page';

export const Route = createFileRoute('/store/revisions')({
	component: StoreRevisionsPage,
});
